import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false });

const whiteList = ['/screen-display', '/login', '/auth-redirect', '/auth/register', '/auth/forgetPassword', '/auth/changePassword', '/auth/login', "/test"]; // no redirect whitelist

router.beforeEach(async(to, from, next) => {

    NProgress.start();
    //设置title
    document.title = getPageTitle(to.meta.title);

    //获取 token
    const hasToken = getToken();

    if (typeof hasToken != "undefined" && hasToken) {
        if (['/auth/login', '/auth/register', '/auth-redirect', '/auth/forgetPassword', '/auth/changePassword'].includes(to.path)) {
            // if is logged in, redirect to the home page
            next({ path: '/dashboard' });
            NProgress.done();
        } else {
            // determine whether the user has obtained his permission roles through getInfo
            const hasRoles = store.getters.roles && store.getters.roles.length > 0;
            if (hasRoles) {
                next()
            } else {
                try {
                    const { roles, permissions } = await store.dispatch('user/getInfo');
                    // generate accessible routes map based on roles
                    const accessRoutes = await store.dispatch('permission/generateRoutes', { roles: roles, pers: permissions });
                    // dynamically add accessible routes
                    router.addRoutes(accessRoutes);
                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    next({...to, replace: true });
                } catch (error) {
                    // remove token and go to login page to re-login
                    await store.dispatch('user/resetToken');
                    Message.error(error || 'Has Error');
                    next(`/auth/login?redirect=${to.path}`);
                    NProgress.done()
                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next(`/auth/login?redirect=${to.path}`);
            NProgress.done();
        }
    }
});

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
});